export default __webpack_public_path__ + "4fdc7f3f686190f97b5499a983298814.png";